// src/pages/sangamam/sangamamMap.jsx
import React from "react";
import "./sangamamMap.css";

/**
 * Map section shown ONLY on the Sangamam/Thiruporur page, between the
 * Location accordion (Educational/Hospital/IT Sectors) and the
 * "Plot Advantages" cards section. Reuses the same Google Maps embed
 * already used for Thiruporur/Sangamam in the nav "Projects" dropdown
 * (see navHeader.jsx), just shown larger here.
 */
const SangamamMap = () => {
  return (
    <div className="sangamam-map-container">
      <h2 className="sangamam-features-heading green-text heading-bold">
        Find Us on the Map
      </h2>
      <div className="sangamam-map-frame-wrap">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4185.885213569837!2d80.13476417538735!3d12.715962687576482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5257f4cf503461%3A0x3e3e05e15fed4e3!2sAnandham%20Plots%20-%20Thiruporur%20-%20Sangamam!5e1!3m2!1sen!2sin!4v1782455491633!5m2!1sen!2sin"
          width="100%"
          height="420"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Sangamam Location Map"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default SangamamMap;
